import { render, staticRenderFns } from "./VolunteerSection.vue?vue&type=template&id=cb5db48a&"
import script from "./VolunteerSection.vue?vue&type=script&lang=js&"
export * from "./VolunteerSection.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports